<template>
  <div>
    <b-form-select
      class="h-100 dropDown"
      v-model="selected"
      :options="options"
      required
      @change="onChange($event)"
      :disabled="disabled"
    ></b-form-select>
  </div>
</template>

<script>
export default {
  props: ["options", "disabled", "selected"],
  data() {
    return {
      selected: null
    };
  },
  methods: {
    onChange(event) {
      this.$emit("dropdownChange", event);
    }
  }
};
</script>
<style scoped>
.dropDown {
  font-family: "Source Sans Pro", sans-serif;
}
</style>